<template>
  <UiDrawer v-model="showLiveQuiz" placement="right">
    <div class="quiz-panel">
      <div class="quiz-panel-header">
        <i />
        <UiLabel shadow-color="#333">
          实时竞猜
        </UiLabel>
      </div>
      <div class="scroll-box">
        <div class="quiz-list" v-if="liveQuizList.length">
          <div class="quizBox" v-for="(item, key) in liveQuizList" :key="key" :data-choosenum="item.chooseNum">
            <div class="header">
              <div class="finish">{{ formatTime(item.endAt) }}</div>
            </div>
            <div class="content" :class="hasOpponent(item) ? 'double' : 'single'">
              <div class="left-box">
                <div class="icon-bg">
                  <div class="icon">
                    <div
                      class="head"
                      :style="{
                        'background-image': `url(${item.questionDetail.objList[0].avatar})`,
                      }"
                    ></div>
                    <div class="frame"></div>
                  </div>
                  <div class="name">
                    <div class="label-box">
                      <span class="label-shadow">{{ item.questionDetail.objList[0].name }}</span>
                      <span class="label-text">{{ item.questionDetail.objList[0].name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="middle-box">
                <div class="bg-deco"></div>
                <div class="question">
                  <div class="title">
                    <div class="label-box">
                      <span class="label-shadow">{{ item.questionDetail.title }}</span>
                      <span class="label-text">{{ item.questionDetail.title }}</span>
                    </div>
                  </div>
                </div>
                <div class="compared">
                  <div class="inner">
                    <div class="left-side" :class="{ 'is-zero': Number(getItemPopularity(item, 0)) === 0 }" :style="{ width: `${getItemPopularity(item, 0)}%` }"></div>
                    <div class="right-side" :style="{ width: `${getItemPopularity(item, 1)}%` }"></div>
                  </div>
                  <div class="desc left-desc">
                    <div class="label-box" v-if="item.questionDetail.answers[0]">
                      <span class="label-shadow">{{ getItemPopularity(item, 0) }} % 支持</span>
                      <span class="label-text">{{ getItemPopularity(item, 0) }} % 支持</span>
                    </div>
                    <div class="label-box" v-else>
                      <span class="label-shadow">0 % 支持</span>
                      <span class="label-text">0 % 支持</span>
                    </div>
                  </div>
                  <div class="desc right-desc">
                    <div class="label-box" v-if="item.questionDetail.answers[1]">
                      <span class="label-shadow">{{ getItemPopularity(item, 1) }} % 支持</span>
                      <span class="label-text">{{ getItemPopularity(item, 1) }} % 支持</span>
                    </div>
                    <div class="label-box" v-else>
                      <span class="label-shadow">0 % 支持</span>
                      <span class="label-text">0 % 支持</span>
                    </div>
                  </div>
                </div>
                <div class="chooseList" v-if="item.questionDetail.answers.length">
                  <template v-for="(choose, index) in item.questionDetail.answers" :key="`choose-${choose.answerCode}`">
                    <div class="choose-item" @click="handleQuiz(item, item.questionDetail, choose, index)">
                      <div class="rate">赔率：{{ choose.lossRate }}</div>
                      <div class="choose-btn" :class="index === 0 ? 'left-btn' : 'right-btn'">
                        <UiLabel>{{ choose.answer }}</UiLabel>
                      </div>
                    </div>
                    <div class="vs-icon" v-if="hasOpponent(item) && index === 0"></div>
                  </template>
                </div>
              </div>
              <div class="right-box" v-if="hasOpponent(item)">
                <div class="icon-bg">
                  <div class="icon">
                    <div
                      class="head"
                      :style="{
                        'background-image': `url(${item.questionDetail.objList[1].avatar})`,
                      }"
                    ></div>
                    <div class="frame"></div>
                  </div>
                  <div class="name">
                    <div class="label-box">
                      <span class="label-shadow">{{ item.questionDetail.objList[1].name }}</span>
                      <span class="label-text">{{ item.questionDetail.objList[1].name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no-quiz" v-else>
          <UiEmpty layout="column" tip="竞猜暂未开启"></UiEmpty>
        </div>
      </div>
    </div>
    <template #close="{ close }">
      <div class="btn-close" @click.stop="close"><i></i></div>
    </template>
  </UiDrawer>
  <!-- 投注弹窗独立于抽屉, 由 modal store 控制显隐 -->
  <Betting />
</template>

<script setup>
import { ref, computed, onBeforeUnmount } from 'vue'
import * as api from "@/service/index";
import { useAppStore } from '@/store'
import { useModal } from '@/composables/useModal'
import { usePrompt } from '@/composables/usePrompt'
import UiDrawer from '@/components/ui-drawer.vue'
import Betting from "@/views/quiz/modal/betting";
import UiEmpty from '@/components/ui-empty'
import UiLabel from "@/components/ui-label.vue";

const appStore = useAppStore()
const { showPrompt } = usePrompt()

const token = computed(() => appStore.token)

const showLiveQuiz = ref(false);
const timer = ref(null);
const liveQuizList = ref([]);

useModal('live-quiz', showLiveQuiz, {
  async onOpen() {
    await fetchLiveQuizList()
  }
})

async function fetchLiveQuizList() {
  if (!token.value) return
  try {
    const { status, data } = await api.realTimeGuessing(token.value)
    if (status === 200) liveQuizList.value = data
  } catch (err) {
    console.error(err)
  }
}

function formatTime(val) {
  let date = new Date(val);
  let hour = date.getHours();
  hour = hour < 10 ? "0" + hour : hour;
  let min = date.getMinutes();
  min = min < 10 ? "0" + min : min;
  return `${hour}:${min} 截止`;
}
function getDateTime(date) {
  return new Date(date).getTime();
}


async function handleQuiz(quizInfo, selectInfo, answerInfo, index) {
  if (quizInfo.answer && quizInfo.answer !== 0) {
    showPrompt("本场竞猜已结束");
  } else {
    let currentTime = new Date();
    let result = await api.reqcurrentTime();
    if (result.status === 200) {
      currentTime = result.data;
    }

    if (getDateTime(currentTime) >= getDateTime(quizInfo.endAt)) {
      showPrompt("本场竞猜已结束");
    } else if (
      getDateTime(currentTime) < getDateTime(quizInfo.startAt)
    ) {
      showPrompt("本场竞猜未开始");
    } else {
      let obj = {};
      let other = {};
      let quizSubType = {
        1: "schedule",
        2: "live",
        3: "rankpk",
        4: "disusepk",
      }
      if (quizInfo.stype === 1) {
        obj = {
          question_id: quizInfo.id,
          lossRate: selectInfo.lossRate,
          obj_avatar: selectInfo.objList[0]?.avatar,
          obj_name: selectInfo.objList[0]?.name,
          answer_code: answerInfo.answerCode,
          answer_name: answerInfo.answer,
          ratios: selectInfo.answers[index].popularity
        };
      } else if (quizInfo.stype === 2) {
        obj = {
          question_id: quizInfo.id,
          lossRate: answerInfo.lossRate,
          obj_avatar: selectInfo.objList[index]?.avatar,
          obj_name: selectInfo.objList[index]?.name,
          answer_code: answerInfo.answerCode,
          answer_name: answerInfo.answer,
          ratios: selectInfo.answers[index].popularity
        };
        other = {
          stype: 2,
          schedule_id: quizInfo.scheduleCode,
          match_title: quizInfo['questionDetail']['title'],
          match_id: quizInfo.matchCode,
          type: quizInfo.type,
          subType: quizSubType[quizInfo.type],
          obj_name: selectInfo.objList[0]?.name,
        };
      }
      appStore.openModal({ id: 'quiz-betting', params: { info: obj, other } });
    }
  }
}

function liveGuess() {
  if (timer.value) clearInterval(timer.value)
  timer.value = setInterval(() => {
    // 打开状态下每 30s 刷新一次数据
    if (showLiveQuiz.value) fetchLiveQuizList()
  }, 30000)
}
function getItemPopularity(item, index) {
  return Number(item.questionDetail.answers[index]?.popularity * 100).toFixed(0) || 0
}

// 单/双边判断: 与 pk-card hasOpponent 一致 (第二个战队 code 存在, 且和第一个不同)
function hasOpponent(item) {
  const list = item?.questionDetail?.objList || []
  const code0 = list[0]?.code
  const code1 = list[1]?.code
  return !!code1 && code1 !== code0
}

liveGuess()

onBeforeUnmount(() => {
  clearInterval(timer.value);
});
</script>

<style lang="scss" scoped>
@import "./quiz-panel";
</style>
